import Service from '@/service/index.js';
export default {
  components: {
  },
  props: ['item', 'projectSubType'],
  data() {
    return {
      projectTypeList: []
    };
  },
  created() {
    const obj = {
      TRANSFEREE_PURPOSE: 'projectTypeList'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  computed: {
  },
  methods: {
  }
};
